<template>
  <div class="setting-body">
    <div class="setting-body-title m-b-20">{{ routerTitle }}</div>
    <div class="invoice-list">
      <el-form size="small" inline label-suffix="：" :model="filterForm">
        <el-form-item style="width: 100%">
          <el-radio-group
            v-model="filterForm.chargeType"
            size="medium"
            @change="changeChargeType"
          >
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              v-for="item in feeTypeList"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="!isPersonalPay" label="付款单位">
          <el-select v-model="filterForm.buyerCompanyId">
            <el-option
              v-for="item in companyList"
              :key="item.companyName"
              :label="item.companyName"
              :value="item.companyId"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isPersonalPay && showCompany" label="收费企业">
          <purchaser-or-agency-async-select
            v-model="filterForm.sellerCompanyId"
          />
        </el-form-item>
        <el-form-item label="发票申请状态">
          <el-select v-model="filterForm.status">
            <el-option label="全部" value="" />
            <el-option
              v-for="item in invoicingStatusArray"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="operate">
          <div class="flex col-center">
            <el-button type="primary" @click="handleSearch">
              查询
            </el-button>
            <el-button class="m-r-10" @click="handleReset">
              重置
            </el-button>
            <el-button
              style="margin: 0"
              type="text"
              icon="el-icon-info"
              circle
              class="tips"
              @click="tipDialogVisible = true"
            >提示</el-button>
          </div>
        </el-form-item>
      </el-form>

      <jczh-table-content
        :data="listData"
        :option="listOption"
        pagination
        :total="total"
        :page.sync="page"
        :limit.sync="size"
      >
        <template #invoiceCodeHeader>
          <span class="m-r-4">提取码</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="提取码用于第三方电子发票服务平台发票提取"
            placement="top"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </template>
        <template #invoiceCode="{ row }">
          <span>{{ row.invoiceCode || '-' }}</span>
          <el-button
            v-if="row.invoiceCode"
            :id="`invoiceCode${row.invoiceCode}`"
            type="text"
            :data-clipboard-text="row.invoiceCode"
            @click="copyInvoiceCode(row.invoiceCode)"
          >复制</el-button>
        </template>
        <template v-slot:last>
          <el-table-column
            label="操作"
            align="center"
            width="160px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-button
                v-if="!inReject(row)"
                type="text"
                @click="lookDetail(row)"
              >支付详情</el-button>
              <el-button
                v-if="inReject(row)"
                type="text"
                @click="reApply(row)"
              >拒绝原因</el-button>
              <el-button
                v-if="inInvoiced(row) && !inSpecial(row)"
                type="text"
                @click="download(row)"
              >下载</el-button>
            </template>
          </el-table-column>
        </template>
      </jczh-table-content>

      <!-- 提示信息弹窗 -->
      <el-dialog
        :visible.sync="tipDialogVisible"
        center
        class="dialog"
        title="提示"
        :close-on-press-escape="true"
        :close-on-click-modal="false"
        width="600px"
      >
        <div class="dialog-content">
          <p>
            1、报名费/标书费/签章费/只可申请电子普通发票。服务费可选择申请纸质专用发票，如有特殊问题，请与收费企业联系；
          </p>
          <p>
            2、如发票状态已开具情况下无下载链接，请联系收费企业进行线下邮寄；
          </p>
          <p>3、根据不同收费企业，纸质专用发票可能存在支付邮寄费用情况；</p>
        </div>
        <div class="dialog-footer">
          <el-button
            size="small"
            @click="tipDialogVisible = false"
          >关闭</el-button>
        </div>
      </el-dialog>

      <!-- 支付详情 -->
      <pay-content-list-dialog
        :visible.sync="payContentVisible"
        :invoice-apply-id="invoiceApplyId"
      />

      <!-- 重新申请 -->
      <re-apply-dialog
        :visible.sync="reApplyVisible"
        :reject-reason="rejectReason"
        @confirm="reApplyConfirm"
      />
      <!-- 申请开票 -->
      <apply-invoice-drawer
        :visible.sync="applyInvoiceDrawerVisible"
        :company-id="filterForm.buyerCompanyId"
        :ids="applyIdList"
        :charge-type="chargeType"
        :apply-type="applyType"
      />

      <!-- 发票列表弹窗 -->
      <el-dialog
        title="下载发票"
        class="dialog"
        center
        :close-on-press-escape="true"
        :close-on-click-modal="false"
        :visible.sync="downloadDialogVisible"
        width="600px"
      >
        <div class="dialog-content">
          <el-table border :data="downloadList" style="width: 100%">
            <el-table-column label="名称" align="center" min-width="100px">
              <template slot-scope="{ $index }">
                <span>发票{{ $index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100px">
              <template slot-scope="{ row }">
                <el-button
                  v-if="showDownloadButton(row)"
                  type="text"
                  @click="downloadInvoice(row)"
                >下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dialog-footer">
          <el-button
            size="small"
            @click="downloadDialogVisible = false"
          >关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
// mixin
import { listFilterMixin } from 'jczh-ui'
import personalMixin from '@/views/personal-center/personalMixin'
// vuex
import { mapState } from 'vuex'
// 字典
import {
  feeTypeDict,
  personalFeeTypeDict,
  invoiceApplyStatusDict,
  invoiceTypeDict
} from '@/dictionary/financial'
// 组建
import PayContentListDialog from '@/components/PersonalCenter/PayContentListDialog'
import ReApplyDialog from '@/components/PersonalCenter/ReApplyDialog'
import ApplyInvoiceDrawer from '@/components/Drawer/ApplyInvoiceDrawer'
import PurchaserOrAgencyAsyncSelect from '@/components/PersonalCenter/PurchaserOrAgencyAsyncSelect'
// 接口
import {
  getInvoiceApplyListApi,
  getInvoiceDownloadListApi
} from '@/api/financial/financial'
// 工具
import { strToThousands } from '@/utils/utils'

export default {
  name: 'InvoiceList',

  components: {
    PayContentListDialog,
    ReApplyDialog,
    ApplyInvoiceDrawer,
    PurchaserOrAgencyAsyncSelect
  },

  mixins: [listFilterMixin, personalMixin],

  data() {
    return {
      feeTypeDict,
      personalFeeTypeDict,
      invoiceApplyStatusDict,
      invoiceTypeDict,
      filterForm: {
        // 购买方公司id
        buyerCompanyId: '',
        // 收费类型
        // chargeType: feeTypeDict下次z   .SIGN_ VBUP_PAY.value,
        chargeType: '',
        // 销售方公司id
        sellerCompanyId: '',
        // 开票状态
        status: '',
        // 支付类型
        orderType: 0
      },
      listData: [],
      total: 0,
      listOption: [
        {
          label: '收费类型',
          prop: 'chargeTypeName',
          minWidth: 160
        },
        {
          label: '收费企业',
          prop: 'sellerCompanyName',
          minWidth: 160
        },
        {
          label: '发票金额（元）',
          prop: 'amount',
          minWidth: 120,
          filter: value => strToThousands(value)
        },
        {
          label: '发票类型',
          prop: 'invoiceType',
          filter: value => invoiceTypeDict.translate(value).label || '-',
          minWidth: 120
        },
        {
          label: '提取码',
          prop: 'invoiceCode',
          slotName: 'invoiceCode',
          headerSlot: 'invoiceCodeHeader',
          minWidth: 100
        },
        {
          label: '申请时间',
          prop: 'applyTime',
          minWidth: 160
        },
        {
          label: '开票状态',
          prop: 'status',
          minWidth: 100,
          tagDict: invoiceApplyStatusDict
        },
        {
          label: '开票名称',
          prop: 'buyerName',
          minWidth: 200
        },
        {
          label: '纳税人识别号',
          prop: 'buyerTaxNo',
          minWidth: 180
        },
        {
          label: '申请单号',
          prop: 'invoiceSerialNo',
          minWidth: 240
        }
      ],
      // 控制提示弹窗的显示
      tipDialogVisible: false,
      // 控制支付详情弹窗的显示
      payContentVisible: false,
      // 当前查看支付详情的记录id
      invoiceApplyId: '',
      // 控制重新申请弹窗的显示
      reApplyVisible: false,
      rejectReason: '',
      // 控制申请侧边抽屉的显示
      applyInvoiceDrawerVisible: false,
      applyIdList: [],
      chargeType: 0,
      applyType: 0,
      // 控制下载发票弹窗的显示
      downloadDialogVisible: false,
      // 可下载的发票列表
      downloadList: [],
      FEEDICT: feeTypeDict.dictArray
    }
  },

  computed: {
    ...mapState('user', ['companyList', 'userId']),
    ...mapState('company', ['companyId']),

    invoicingStatusArray() {
      const tempArray = invoiceApplyStatusDict.dictArray
      tempArray.shift()
      return tempArray
    },

    // 已拒绝状态显示重新申请操作
    inReject() {
      return row => {
        return row.status === invoiceApplyStatusDict.REJECTED.value
      }
    },

    // 已申请状态显示下载操作
    inInvoiced() {
      return row => {
        return row.status === invoiceApplyStatusDict.INVOICED.value
      }
    },

    // 专票（非专票下载可查看）
    inSpecial() {
      return row =>
        row.invoiceType === invoiceTypeDict.SPECIAL_PAPER_INVOICE.value
    },

    // 费用类型列表
    feeTypeList() {
      return feeTypeDict.array
    },

    // 收费企业搜索项展示条件
    showCompany() {
      return (
        this.filterForm.chargeType !== feeTypeDict.AGENT_SERVICE_FEE_PAY.value
      )
    },

    // 是否是个人费用
    isPersonalPay() {
      return this.filterForm.chargeType === feeTypeDict.VAS.value
    }
  },

  watch: {
    companyId: {
      handler(val) {
        if (!val) return

        this.filterForm.buyerCompanyId = val
        this.defineFormReset()
        this.handleSearch()
      },
      immediate: true
    }
  },

  created() {
    this.$store.dispatch('user/getJoinedCompany')
  },

  methods: {
    /**
     * 修改支付类型
     */
    changeChargeType() {
      // 如果当前的收费类型是平台增值服务，则清空付款单位和收费企业
      if (this.filterForm.chargeType === feeTypeDict.VAS.value) {
        this.filterForm.buyerCompanyId = ''
        this.filterForm.sellerCompanyId = ''
      }
      this.cache()
      this.getList()
    },

    isArray(value) {
      return Object.prototype.toString.call(value) === '[object Array]'
    },

    // 复制提取码
    copyInvoiceCode(text) {
      const clipboard = new Clipboard(`#invoiceCode${text}`)
      clipboard.on('success', e => {
        // 复制成功
        this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 复制失败
        this.$message.error('复制成功')
        clipboard.destroy()
      })
    },

    async getList() {
      try {
        this.epitaxy()

        // 如果查询的费用类型为平台增值服务之外的类型，
        // 且付款单位为空，则将其赋值为当前登录企业id或者企业列表中的第一家企业的id
        if (
          this.filterForm.chargeType !== feeTypeDict.VAS.value &&
          !this.filterForm.buyerCompanyId
        ) {
          this.filterForm.buyerCompanyId =
            this.companyId || this.companyList[0]?.companyId || ''
        }

        const query = Object.assign(
          {},
          { pageNum: this.page, pageSize: this.size },
          this.filterForm
        )

        const res = await getInvoiceApplyListApi(query)
        this.listData = res.data?.records || []
        this.total = res.data?.total || 0
      } catch (err) {
        if (err?.data?.message) {
          this.$message.error(err.data.message || '获取发票记录失败')
        }
      }
    },

    lookDetail(row) {
      this.payContentVisible = true
      this.invoiceApplyId = row.id
    },

    reApply(row) {
      this.reApplyVisible = true
      this.rejectReason = row.rejectReason
      this.amount = Number(row.amount) || 0
    },

    reApplyConfirm() {
      this.applyInvoiceDrawerVisible = true
    },

    async download(row) {
      try {
        const res = await getInvoiceDownloadListApi(row.id)
        this.downloadList = res.data
        // 如果是单张发票，直接下载
        if (res?.data?.length === 1) {
          window.open(res.data[0])
        } else {
          this.downloadDialogVisible = true
        }
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '获取下载地址失败')
        }
      }
    },

    /**
     * 控制发票下载按钮的显示
     * @param row
     */
    showDownloadButton(row) {
      // 线下开票的发票不能下载
      if (
        row.invoiceApplyStatus === invoiceApplyStatusDict.OFFLINE_INVOICE.value
      ) {
        return false
      }
      return true
    },

    downloadInvoice(row) {
      window.open(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-body {
  width: 1030px;
  padding: 20px;
  background-color: $white-color;
  overflow: hidden;
  position: relative;
  border-radius: 4px;

  .setting-body-title {
    text-align: left;
    font-size: 20px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 25px;
      background-color: $primary-color;
      vertical-align: bottom;
      margin-right: 10px;
    }
  }
}

.invoice-list {
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 1rem;
    }
  }
}

.tips {
  color: $text-third-color;
}

.dialog {
  .dialog-content {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px 10px 20px;
  }
  .dialog-footer {
    margin-bottom: 20px;
  }
}
</style>
